import { Box } from '@factorialco/deprecated-design-system'
import { OneAlert } from '@factorialco/f0-react/dist/experimental'
import { AccessCalendarSyncItemFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

import { useCreateCalendarSync } from 'modules/cronofy/components/ConnectMyCalendar/useCreateCalendarSync'

interface ConnectCalendarBannerProps {
  accessCalendarSync: AccessCalendarSyncItemFragment | null
  loading: boolean
}

export const ConnectCalendarBanner = ({
  accessCalendarSync,
  loading,
}: ConnectCalendarBannerProps) => {
  const {
    access: { id: accessId },
  } = useCurrentSession()

  const isCalendarConnected = !!accessCalendarSync?.sub

  const { createCalendarSync } = useCreateCalendarSync()

  const syncCalendar = async () => {
    if (accessCalendarSync?.oauthUrl) {
      window.location.href = accessCalendarSync.oauthUrl
    }
    const result = await createCalendarSync({ accessId })
    const handled = handleResult(result, () => undefined)
    if (handled.success && handled.data.calendarSync && handled.data.calendarSync.oauthUrl) {
      window.location.href = handled.data.calendarSync.oauthUrl
    }
  }

  return loading || isCalendarConnected ? null : (
    <Box paddingX="s16" paddingBottom="s16">
      <OneAlert
        action={{
          label: i18n.t('meetings.one_on_ones.connect_calendar_banner.connect_calendar'),
          onClick: syncCalendar,
        }}
        description={i18n.t('meetings.one_on_ones.connect_calendar_banner.description')}
        title={i18n.t('meetings.one_on_ones.connect_calendar_banner.title')}
        variant="warning"
      />
    </Box>
  )
}
